"use client"

import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import "../styles/adminSidebar.css"
import logo from "../assets/logo.png"
import {
  FaBars,
  FaChartBar,
  FaMoneyBill,
  FaMoneyBillWave,
  FaCalendarAlt,
  FaCreditCard,
  FaUser,
  FaShoppingCart,
  FaPercentage,
  FaSignOutAlt,
  FaExclamationCircle,
  FaFileAlt,
  FaFileExport,
  FaPrint,
  FaWhatsapp,
  FaBalanceScale,
  FaGift,
  FaBell,
  FaBullhorn,
  FaTv,
  FaLink,
  FaLayerGroup, // ícone para Parcelamentos
} from "react-icons/fa"

const AdminSidebar = () => {
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  const handleLogout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    navigate("/login")
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <>
      {/* Botão Hamburguer visível no mobile */}
      <button className="sidebar-toggle-btn" onClick={toggleSidebar} aria-label="Toggle Menu">
        <FaBars />
      </button>

      <div className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="logo">
          <img src={logo || "/placeholder.svg"} alt="Logo A Senha" />
        </div>

        <ul>
          <li>
            <Link to="/admin/dashboard" onClick={() => setSidebarOpen(false)}>
              <FaChartBar /> Dashboard
            </Link>
          </li>
          <li>
            <Link to="/admin/financeiro-admin" onClick={() => setSidebarOpen(false)}>
              <FaMoneyBill /> Financeiro
            </Link>
          </li>
          {/* ✅ NOVO: Painel de Parcelamentos */}
          <li>
            <Link to="/admin/parcelamentos" onClick={() => setSidebarOpen(false)}>
              <FaLayerGroup /> Parcelamentos
            </Link>
          </li>
          <li>
            <Link to="/admin/despesas">
              <FaMoneyBill /> Despesas
            </Link>
          </li>
          <li>
            <Link to="/admin/despesas-circuitos">
              <FaMoneyBillWave /> Despesas Circ.
            </Link>
          </li>
          <li>
            <Link to="/admin/contabilidade" onClick={() => setSidebarOpen(false)}>
              <FaBalanceScale /> Contabilidade
            </Link>
          </li>
          <li>
            <Link to="/admin/vales" onClick={() => setSidebarOpen(false)}>
              <FaMoneyBill /> Vales
            </Link>
          </li>
          <li>
            <Link to="/admin/descontos" onClick={() => setSidebarOpen(false)}>
              <FaPercentage /> Descontos
            </Link>
          </li>
          <li>
            <Link to="/admin/eventos" onClick={() => setSidebarOpen(false)}>
              <FaCalendarAlt /> Eventos
            </Link>
          </li>
          <li>
            <Link to="/admin/vendas" onClick={() => setSidebarOpen(false)}>
              <FaCreditCard /> Vendas
            </Link>
          </li>
          <li>
            <Link to="/admin/afiliados" onClick={() => setSidebarOpen(false)}>
              <FaLink /> Afiliados Eventos
            </Link>
          </li>
          <li>
            <Link to="/admin/marketing" onClick={() => setSidebarOpen(false)}>
              <FaBullhorn /> Campanhas
            </Link>
          </li>
          <li>
            <Link to="/admin/transmissoes" onClick={() => setSidebarOpen(false)}>
              <FaTv /> Transmissões TV
            </Link>
          </li>
          <li>
            <Link to="/admin/notificacao-app" onClick={() => setSidebarOpen(false)}>
              <FaBell /> Notificação App
            </Link>
          </li>
          <li>
            <Link to="/admin/profissionais" onClick={() => setSidebarOpen(false)}>
              <FaUser /> Profissionais
            </Link>
          </li>
          <li>
            <Link to="/admin/financeiro-circuitos" onClick={() => setSidebarOpen(false)}>
              <FaMoneyBill /> Financeiro C.
            </Link>
          </li>
          <li>
            <Link to="/admin/raspadinha-vendas" onClick={() => setSidebarOpen(false)}>
              <FaGift /> Vendas Raspadinha
            </Link>
          </li>
          <li>
            <Link to="/admin/donos" onClick={() => setSidebarOpen(false)}>
              <FaUser /> Donos
            </Link>
          </li>
          <li>
            <Link to="/admin/clientes" onClick={() => setSidebarOpen(false)}>
              <FaShoppingCart /> Clientes
            </Link>
          </li>
          <li>
            <Link to="/admin/raspadinha" onClick={() => setSidebarOpen(false)}>
              <FaGift /> Raspadinha
            </Link>
          </li>
          <li>
            <Link to="/admin/relatorio">
              <FaFileAlt /> Relatório
            </Link>
          </li>
          <li>
            <Link to="/admin/notificacao-whatsapp" onClick={() => setSidebarOpen(false)}>
              <FaWhatsapp /> Notificação WhatsApp
            </Link>
          </li>
          <li>
            <Link to="/admin/senhas-limpas">
              <FaPrint /> Imprimir Senhas
            </Link>
          </li>
          <li>
            <Link to="/admin/taxas" onClick={() => setSidebarOpen(false)}>
              <FaPercentage /> Gerenciar Taxas
            </Link>
          </li>
          <li>
            <Link to="/admin/gateways" onClick={() => setSidebarOpen(false)}>
              <FaCreditCard /> Gateways
            </Link>
          </li>
          <li>
            <Link to="/admin/patrocinadores" onClick={() => setSidebarOpen(false)}>
              <FaChartBar /> Patrocinadores
            </Link>
          </li>
          <li>
            <Link to="/admin/avisos-admin" onClick={() => setSidebarOpen(false)}>
              <FaExclamationCircle /> Avisos
            </Link>
          </li>
          <li>
            <Link to="/admin/circuitos">
              <FaFileAlt /> Circuitos
            </Link>
          </li>
          <li>
            <Link to="/admin/exportacao">
              <FaFileExport /> Exportar
            </Link>
          </li>
        </ul>
        <button className="logout-button" onClick={handleLogout}>
          <FaSignOutAlt /> Sair
        </button>
      </div>
    </>
  )
}

export default AdminSidebar
